$(document).on("click", ".question_product,.faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question').removeClass('active');
    jQuery('.question_product,.faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});



$(document).on("click", ".custom_button", function (e) {
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if (jQuery(this).hasClass("active")) {
   jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
    jQuery(this).removeClass('active');
video.trigger('pause');
} else {
video.trigger('play');
  jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
    jQuery(this).addClass('active');
}
});








$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('#product').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});



function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).scroll(function () {
    $('.custom_counter .icons_with_text_flex').each(function () {
      var this_element =  $(this);
      if (this_element.hasClass("start_count")) {
} else {
        if (isScrolledIntoView(this) === true) {
            this_element.addClass('start_count');
$('.count_js').each(function () {
    $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
        }, {
        duration: 1000,
        easing: 'swing',
        step: function (now) {                      
            $(this).text(Math.ceil(now));
        }
    });
});
        }
      }
    });

});


$(document).on("click", ".choose_color_trigger_main", function (e) {
  e.preventDefault();
$('.custom_popup_main').show();
});


$(document).on("change", "[data-smartrr-selling-plans-select]", function (e) {
var selected_plan = $(this).val();
$('[data-smartrr-selling-plan-input]').val(selected_plan);
$('.selling_plan_trigger').hide();
$('.selling_plan_trigger[data_tab="'+selected_plan+'"]').show();
});
$(document).on("change", "[data-smartrr-selling-plan-group-input]", function (e) {
var selected_plans = $(this).val();
var selected_plan = $('[data-smartrr-selling-plans-select]').val();
if (selected_plans=="") {
$('[data-smartrr-selling-plan-input]').val(selected_plans);
} else {
$('[data-smartrr-selling-plan-input]').val(selected_plan);
}
});

$(document).on("click", ".custom_subscribe_options_flex_item", function (e) {
var selected_plan = $(this).attr('data_tab');
$('.custom_subscribe_options_flex_item').removeClass('selected');
$(this).addClass('selected');
$('[data-smartrr-selling-plans-select]').val(selected_plan).trigger('change');
});



$(document).on("click", '.test--sbyo__qty-up', function (e) {
var this_element = $(this);
 setTimeout(function () {
  var colors = 0;
var quantity = parseInt(this_element.parents('.test--sbyo__option-outer').find('.test--sbyo__qty').text());
if(quantity>0){
colors = colors+quantity;
for(var i = 0; i < quantity; i++) {
var product_id = this_element.parents('.test--sbyo__option-outer').attr('data-variant');
var selected_color = this_element.parents('.test--sbyo__option-outer').find('.test--sbyo__option-inner').attr('style');
$('.selected_colors_right_item2:not(.active)').eq(0).find('.selected_color2').attr('style',selected_color);
$('.selected_colors_right_item2:not(.active)').eq(0).find('.trigger_remove').attr('data-variant',product_id);
$('.selected_colors_right_item2:not(.active)').eq(0).addClass('active');
} 
}
}, 100);
});


$(document).on("click", '.test--sbyo__qty-down', function (e) {
var this_element = $(this);
 setTimeout(function () {
  var colors = 0;
var quantity = parseInt(this_element.parents('.test--sbyo__option-outer').find('.test--sbyo__qty').text());
colors = colors+quantity;
for(var i = -1; i < quantity; i++) {
var product_id = this_element.parents('.test--sbyo__option-outer').attr('data-variant');
if (colors == 1){
$('.trigger_remove[data-variant="'+product_id+'"]').eq(1).parents('.selected_colors_right_item2.active').removeClass('active').find('.selected_color').attr('style','');
} else if (colors == 0){
$('.trigger_remove[data-variant="'+product_id+'"]').parents('.selected_colors_right_item2.active').removeClass('active'); 
}
} 
}, 100);
});

$(document).on("click", ".trigger_remove", function (e) {
var selected_variant = $(this).attr('data-variant');
$('.test--sbyo__option-outer[data-variant="'+selected_variant+'"] .test--sbyo__qty-down').trigger('click');
});




$(document).on("click", ".custom_popup_bg,.custom_popup_close", function (e) {
  e.preventDefault();
$('.custom_popup_main').hide();
  var colors = 0;

$('.test--sbyo__qty').each(function(){
var quantity = parseInt($(this).text());
colors = colors+quantity;
if(quantity>0){
for(var i = 0; i < quantity; i++) {
var selected_color = $(this).parents('.test--sbyo__option-outer').find('.test--sbyo__option-inner').attr('style');
$('.selected_colors_right_item:not(.active)').eq(0).addClass('active').find('.selected_color').attr('style',selected_color);
} 
}
});
if (colors == 1){
$('.selected_colors_right_item.active').eq(1).removeClass('active').find('.selected_color').attr('style','');
} else if (colors == 0){
$('.selected_colors_right_item.active').removeClass('active'); 
}

if (colors == 2){
$('.landing_page_product .custom_hk_button').removeAttr('disabled');
} else {
$('.landing_page_product .custom_hk_button').attr('disabled','disabled');
}
});
